export default function (str: string | undefined): string {
	if (!str) { return "" }
	const digitsArray = str.match(/\d/g);
	if (!digitsArray) { return str }
	return digitsArray.toString().replace(/,/g, "");
}